import React from 'react'
import Box from '@material-ui/core/Box'
import PlayerOperationLogsForm from '../../../components/admin/player/PlayerOperationLogsForm'
import PlayerOperationLogsTable from '../../../components/admin/player/PlayerOperationLogsTable'

const PlayerOperationLogsPage: React.FC = () => {
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <PlayerOperationLogsForm />
      </Box>
      <Box paddingTop={3}>
        <PlayerOperationLogsTable />
      </Box>
    </Box>
  )
}

export default React.memo(PlayerOperationLogsPage)
